import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import classnames from 'clsx';

import { INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';

import style from './dropdown-inline-message.module.less';
import { ErrorIcon } from './error-icon';

/**
 * @typedef {import('../dropdown-types.d.ts').DropdownInlineMessageType} DropdownInlineMessageType
 */

const messageTypeDisplayInfo = {
  [INLINE_MESSAGE_TYPES.error]: {
    icon: <ErrorIcon className={style.icon} />,
    className: style['is-error'],
  },
  [INLINE_MESSAGE_TYPES.warning]: {
    icon: <FontAwesomeIcon className={style.icon} icon={faExclamationTriangle} />,
    className: style['is-warning'],
  },
  [INLINE_MESSAGE_TYPES.info]: {
    icon: <FontAwesomeIcon className={style.icon} icon={faInfoCircle} />,
    className: style['is-info'],
  },
};

/**
 * @param {object} props
 * @param {React.ReactNode} props.inlineMessage
 * @param {DropdownInlineMessageType} props.inlineMessageType
 * @returns {JSX.Element}
 */
export const DropdownInlineMessage = ({ inlineMessage, inlineMessageType }) => {
  const { icon, className } = messageTypeDisplayInfo[inlineMessageType] || {};

  return (
    <div className={classnames(style['dropdown-inline-message'], className)}>
      {icon}
      <div className={style['inline-message']}>{inlineMessage}</div>
    </div>
  );
};
